export default __webpack_public_path__ + "static/media/apple_download.03589fec.svg";